// extracted by mini-css-extract-plugin
export default {"container":"MainPopover_container__Svtam"};